import { connect } from 'react-redux';
import { isSubmitting, formValueSelector } from 'redux-form';
import Component from './Component';

import componentDidMount from './Handlers/componentDidMount';
import onClickCancel from './Handlers/onClickCancel';
import onClickSubmit from './Handlers/onClickSubmit';
import onClickDelete from './Handlers/onClickDelete';

import { FORM_NAME } from './Form';

const mapStateToProps = (state) => ({
  users: state.core.users,
  submitting: isSubmitting(FORM_NAME)(state),
  drives: formValueSelector(FORM_NAME)(state, 'drives'),
  coVehicle: formValueSelector(FORM_NAME)(state, 'co_vehicle'),
  hasRightToWork: formValueSelector(FORM_NAME)(state, 'has_right_to_work'),
});

const actionCreators = {
  componentDidMount,
  onClickCancel,
  onClickSubmit,
  onClickDelete,
};

export default connect(mapStateToProps, actionCreators)(Component);
